import Layout from '../utils/Layouts/Layout/Layout';
import { useSearchParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Axios from "../Axios";

const Mentorship = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const payment_id = searchParams.get("payment_id");

  useEffect(() => {
    if (!payment_id) return;

  const sendToBackend = async () => {
    try {
      console.log("🚀 Sending request...");
      console.log("➡️ payment_id:", payment_id);

      const res = await Axios.post("/payment/confirm", {
        payment_id
      });

      console.log("✅ RESPONSE STATUS:", res.status);
      console.log("📦 RESPONSE DATA:", res.data);
      console.log("📄 FULL RESPONSE:", res);

    } catch (err) {
      console.error("❌ ERROR FULL:", err);

      if (err.response) {
        console.error("❌ STATUS:", err.response.status);
        console.error("❌ DATA:", err.response.data);
        console.error("❌ HEADERS:", err.response.headers);
      } else if (err.request) {
        console.error("❌ NO RESPONSE (request sent but no reply):", err.request);
      } else {
        console.error("❌ GENERAL ERROR:", err.message);
      }
    }
  };

    sendToBackend();
  }, [payment_id]);

  return (
    <Layout>
      <div>Processing payment...</div>
    </Layout>
  );
};

export default Mentorship;